module.exports = __webpack_public_path__ + "static/spyfall-app-icon-6d14aed4da9d828083f227cd2bcba069.png";